import { Link } from "react-router-dom";
import { Phone, FileText } from "lucide-react";
import { COMPANY } from "../lib/constants";

/**
 * Mobile sticky bottom action bar — always-visible CTAs on small screens.
 * Hidden on desktop where the header CTAs are already visible.
 */
export default function MobileStickyCTA() {
  return (
    <div
      data-testid="mobile-sticky-cta"
      className="md:hidden fixed bottom-0 inset-x-0 z-[55] border-t border-[#E5E7EB] bg-white/95 backdrop-blur-xl shadow-[0_-8px_24px_rgba(0,0,0,0.06)]"
    >
      <div className="grid grid-cols-2 gap-2 p-3 safe-bottom">
        <a
          href={COMPANY.phoneHref}
          data-testid="sticky-call"
          className="inline-flex items-center justify-center gap-2 py-3 rounded-full border border-[#0F5132] text-[#0F5132] text-sm font-medium"
        >
          <Phone className="h-4 w-4" />
          Chiama
        </a>
        <Link
          to="/contatti"
          data-testid="sticky-preventivo"
          className="inline-flex items-center justify-center gap-2 py-3 rounded-full bg-[#D97706] text-white text-sm font-medium shadow-sm"
        >
          <FileText className="h-4 w-4" />
          Preventivo
        </Link>
      </div>
    </div>
  );
}
